export enum BillingTypeEnum {
  INVOICE = "invoice",
  CREDIT = "credit",
  CANCELLATION = "cancellation",
  AFFILIATE = "affiliate",
  CREDIT_PARTNER = "creditPartner",
  CREDIT_CHARGING_STATION = "creditChargingStation",
  CREDIT_CUSTOMER_ACCOUNT = "creditCustomerAccount"
}
